import React from "react";
import styled from "styled-components";
import fetch from "./shared/Fetch";
import AppHeading from "./sharedComponents/AppHeading";
import Table from "./sharedComponents/Table";
import { SumData } from "./Consultants";
import { PageHeading } from "./Reconciliation";
import { format } from "./shared/NumberUtil";
import Spinner from "./sharedComponents/Spinner";

const ReportContainer = styled.div`
  padding: 0 5rem 5rem;
  width: 100%;

  @media (max-width: 900px) {
    padding: 0 2rem 5rem;
  }
  @media (max-width: 750px) {
    padding: 0 1rem 5rem;
  }
`;

const LeadingHeading = styled.td`
  padding: 0.5rem;
  text-align: left;
`;

const ReportTables = styled.div`
  border-collapse: collapse;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 5rem;
`;

const TableContainer = styled.div``;

const SumRow = styled.tr`
  font-weight: bold;
  &:nth-child(2n) {
    background: var(--table-band-background);
  }
`;

const MainLayout = styled.div`
  display: flex;
  margin-left: ${props => (props.sidebarOpen ? "175px" : "0")};
  width: ${props => (props.sidebarOpen ? "calc(100% - 175px)" : "100%")};
  transition: all 0.3s ease-in-out;
`;

class ReconciliationInsights extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      yearWeeks: [],
      reportHeading: "Konsulent",
      monthOffset: 0,
      waitingForData: true,
      departmentDeliveryRates: [],
      groupDeliveryRates: [],
      seniorityDeliveryRates: []
    };
  }

  componentDidMount() {
    this.fetchInsights();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.match.params.offset !== prevProps.match.params.offset ||
      this.props.match.params.weeks !== prevProps.match.params.weeks
    ) {
      this.fetchInsights();
    }
  }

  async setOffsetBack() {
    let monthOffset = this.state.monthOffset - 3;
    this.setState({ monthOffset: monthOffset }, this.fetchReport);
  }
  async setOffsetForward() {
    let monthOffset = this.state.monthOffset + 3;
    this.setState({ monthOffset: monthOffset }, this.fetchReport);
  }
  async setOffsetNow() {
    this.setState({ monthOffset: 0 }, this.fetchReport);
  }

  render() {
    const {
      departmentDeliveryRates,
      groupDeliveryRates,
      seniorityDeliveryRates,
      yearWeeks,
      waitingForData
    } = this.state;

    const {
      departments,
      offset,
      weeks,
      groups,
      seniorities,
      serviceareas
    } = this.props.match.params;

    return (
      <div className="module">
        <AppHeading
          departments={departments}
          offset={offset}
          weeks={weeks}
          groups={groups}
          availableOnly={this.props.match.params.availableOnly}
          seniorities={seniorities}
          serviceareas={serviceareas}
          active={"reconciliation"}
        />

        <MainLayout sidebarOpen={false}>
          <ReportContainer>
            <PageHeading
              departments={departments}
              offset={offset}
              weeks={weeks}
              groups={groups}
              availableOnly={this.props.match.params.availableOnly}
              seniorities={seniorities}
            />
            <Spinner show={waitingForData} />
            <h3 className="page-heading">Innsikt leveringsgrad</h3>
            <ReportTables>
              {departmentDeliveryRates && (
                <InsightTable
                  heading="Lokasjon"
                  data={departmentDeliveryRates}
                  yearWeeks={yearWeeks}
                  params={this.props.match.params}
                  showControls={true}
                  largeLeadingHeader={true}
                />
              )}

              {groupDeliveryRates && (
                <InsightTable
                  heading="Tjeneste"
                  data={groupDeliveryRates}
                  yearWeeks={yearWeeks}
                  params={this.props.match.params}
                  showControls={false}
                  largeLeadingHeader={true}
                />
              )}

              {seniorityDeliveryRates && (
                <InsightTable
                  heading="Stillingsnivå"
                  data={seniorityDeliveryRates}
                  yearWeeks={yearWeeks}
                  params={this.props.match.params}
                  showControls={false}
                  largeLeadingHeader={true}
                />
              )}
            </ReportTables>
          </ReportContainer>
        </MainLayout>
      </div>
    );
  }

  fetchInsights() {
    let offset = this.props.match.params.offset;
    if (!offset) offset = 0;

    let weeks = this.props.match.params.weeks;
    if (!weeks) weeks = 8;

    fetch(`/reconciliation/insights/offset/${offset}/weeks/${weeks}`)
      .then(response => {
        const yearWeeks =
          response.departments.length > 0
            ? Object.keys(response.departments[0].deliveryRates).map(
                week => week
              )
            : [];

        this.setState({
          departmentDeliveryRates: response.departments,
          groupDeliveryRates: response.groups,
          seniorityDeliveryRates: response.seniorities,
          yearWeeks: yearWeeks,
          waitingForData: false
        });
      })
      .catch(reason => {
        this.setState({ waitingForData: false });
        console.log("Something went wrong while fetching insights", reason);
      });
  }
}

export default ReconciliationInsights;

function InsightTable({
  heading,
  data,
  yearWeeks,
  params,
  showControls = true,
  largeLeadingHeader = true
}) {
  return (
    <TableContainer>
      <Table
        yearWeeks={yearWeeks}
        params={params}
        inner="reconciliationinsights"
        leadingHeaders={[heading]}
        hideOverflowFirstColumn={true}
        showControls={showControls}
        largeLeadingHeader={largeLeadingHeader}
      >
        {data.map(item => (
          <SumRow key={item.id}>
            <LeadingHeading title={item.name}>{item.name}</LeadingHeading>
            {Object.values(item.deliveryRates).map((rate, i) => {
              const percent = (rate.actuals / rate.staffed) * 100;
              const value = isNaN(percent) ? "-" : `${format(percent)}%`;
              return <SumData key={i}>{value}</SumData>;
            })}
          </SumRow>
        ))}
      </Table>
    </TableContainer>
  );
}
